import api from '~/services/api';

async function showInfusion(id) {
  const response = await api.get(`/infusions/${id}`);

  return response;
}

async function calendarInfusions({ date, userId = undefined }) {
  const response = await api.get('/calendar/infusions', {
    params: {
      date,
      userId,
    },
  });

  return { infusions: response.data, dates: response.data.map((i) => i.date) };
}

async function calendarShow({ date, userId = undefined }) {
  const response = await api.get(`/calendar/infusions/${date}`, {
    params: {
      userId,
    },
  });

  return { infusions: response.data };
}

export { showInfusion, calendarInfusions, calendarShow };
